<template>
    <!-- MODAL ACADEMY -->
    <b-modal ref="modal-academy" id="modal-academy" size="xl" :hide-header="screenSize > 575" hide-footer class="modal-box" body-class="p-0" @hide="cleanRoute">

    <b-container fluid>
        <b-row :class="screenSize > 992 ? 'mx-5 my-5 text-center' : 'mx-1 my-1 text-center' " style="justify-content: center;">
        <div class="text-center" >
          <img
          class="mb-5 img-ds-logo"
          :src="dropsmartLogo"
          alt="Dropsmart Logo"
          />
        </div>
          
          <!-- VIDEO CONTENT -->
          <DefaultVideoComponent :videoUrl="videoUrl"/>
          <!-- IMAGE CONTENT -->
          <div v-if="false"> 
            <b-img :src="modernCosmeticsImg" fluid-grow alt="Responsive image" style="border-radius: 2rem;"></b-img>
          </div>
        </b-row>
        <!-- STEP NUMBER -->
        <b-row class="mx-5 my-5">
          <h2 v-if="id <= 17" class="font-weight-bold mb-0">{{stepNumber}}: {{stepTitle}}</h2>
          <h2 v-else class="font-weight-bold mb-0">{{stepNumber}}</h2>
        </b-row>

        <b-row class="mx-5 mt-0 mb-5">
          <!-- LEFT COLUMN -->
          <b-col :cols="screenSize > 992 ? 7 : 12" :class="screenSize > 992 ? 'pr-5 mr-3' : 'pr-0 mr-0'" style="padding-left: 0px;">
            <div>
              <!-- SUBTITLE -->
              <p v-if="id === 18" class="font-weight-bold">{{stepTitle}}</p>
              <p v-else class="font-weight-bold">{{subtitle}}</p>

              <!-- TEXT -->
              <AcademyTextLeftModal />
              

            </div>
            <!-- BUTTON -->
            <div class="button-purchase-perk" v-if="showLeftButton">
              <b-link>
                <b-button
                  h-ref="http://www.w3.org/2000/svg"
                  variant="light"
                  >
                  Download Extra Material
                  </b-button>
                </b-link>
            </div>
          </b-col>

          <!-- RIGHT COLUMN -->
          <b-col style="padding-right: 0px;">
            <div :class="screenSize < 992 ? 'divider' : '' "></div>
            <!-- TESTIMONIALS -->
            <div v-if="false">
              <p class="font-weight-bold">Reviews</p>
              <div >
               <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
              <div class="mt-3" >
              <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
              <div class="mt-3" >
               <p>I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a review I'm a reviewI'm a review</p>
               <div>
                <b-avatar variant="light" src="https://placekitten.com/300/300" style="margin-right: 1rem;"></b-avatar>
                <span class="mr-auto">Natali Petesh</span>
               </div>
              </div>
            </div>

            <!-- FORM REVIEW -->
            <div v-if="id === 18">
              <p class="font-weight-bold">Share a review</p>
              <div class="mb-4">
                <p>Your success with Dropsmart is important to us, and it is also important to others.</p>
                <p>You can let people know what to expect when they use Dropsmart through a simple review. This is really easy to do, and it will not take much time, but it does have a strong impact.</p>
                <p>We'd greatly appreciate it if you could share the best thing you like about Dropsmart and how you benefit from it in the comment section below.</p>
                <p>Thank you.</p>
              </div>

              <ReviewForm :messageTitle="stepTitle" :rightButton="rightButton" />
            </div>

            <!-- REVIEW FOR MASTER APP AND PROTIPS-->
            <div v-else>
              <p class="font-weight-bold">Share a review</p>
              <div class="mb-4">  
              </div>
              <ReviewForm :messageTitle="stepTitle" :rightButton="rightButton" />
            </div>

          </b-col>
        </b-row>        
      </b-container>
    
    </b-modal>
</template>

<script>
import DropsmartLogo from '@/assets/images/dropsmart-logo.png';
import DefaultVideoComponent from '@/components/centre/DefaultVideoComponent.vue';
import ReviewForm from '@/components/centre/ReviewForm.vue';
import AcademyTextLeftModal from '@/components/centre/academy/AcademyTextLeftModal.vue';
import ModernCosmetics from "@/assets/images/centre/perks/perks-modal/ModernCosmetics.jpg";

export default {
  name: "AcademyModalComponent",
  components: {
    DefaultVideoComponent,
    AcademyTextLeftModal,
    ReviewForm,
  },
  props: ["academyCardsData", "step"],
  mounted() {
    if (this.$route.name === 'Academy' && this.$route.query.step) {
      let index = parseInt(this.$route.query.step) - 1;
      this.id = this.academyCardsData[index].id;
      this.stepNumber = this.academyCardsData[index].productTitle;
      this.stepTitle = this.academyCardsData[index].modalDescription;
      this.videoUrl = this.academyCardsData[index].videoUrl;
      this.showLeftButton = this.academyCardsData[index].showLeftButton;
      this.subtitle = this.academyCardsData[index].modalSubtitle;
      
      if(this.academyCardsData[index].hasModal) {
        this.$refs['modal-academy'].show();
      }
    }
    this.$root.$on("step-content", (stepContent) => {
      this.id = stepContent.id;
      this.stepNumber = stepContent.productTitle;
      this.stepTitle = stepContent.modalDescription;
      this.videoUrl = stepContent.videoUrl;
      this.showLeftButton = stepContent.showLeftButton;
      this.subtitle = stepContent.modalSubtitle;
    });
    this.screenSize = window.innerWidth;
    },
  data() {
    return {
      dropsmartLogo: DropsmartLogo,
      modernCosmeticsImg: ModernCosmetics,
      id: 0,
      stepNumber: "",
      stepTitle: "",
      videoUrl: "",
      showLeftButton: false,
      rightButton: 'Submit your review',
      subtitle: "",
      screenSize: 1024,
    };
  },
  methods: {
    cleanRoute() {
      this.$router.push({
        name: "Academy",
        query: { category: this.$route.query.category },
      }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
.button-purchase-perk {
  display: flex;
  justify-content: center;
  button {
    font-weight: 700;
    background-color: black; 
    color: #E7E7E7;
    border: none;
    border-radius: 0.4rem;
    padding: 0.5rem 4.5rem 0.5rem 4.5rem;
    margin-top: 1rem;
    &:hover {
      background-color: #E7E7E7;
      color: black; 
    }
  }
}

.divider {
  border: 1px solid #838383;
  margin: 1.4rem 1rem;
}

@media screen and (max-width: 767px) {

  .img-ds-logo {
    width: 50%;
    margin-top: 1.5rem;
  }

}


</style>
